module.exports = __webpack_public_path__ + "media/images/catalogs/items/options/icons/linen-d17768a70cfde948d05056e578938152.svg";